// extracted by mini-css-extract-plugin
module.exports = {"marquee":"marquee_marquee__bvrYF","scroll":"marquee_scroll__n30G8"};